import { Component, OnInit } from '@angular/core';
import { WorkoutProgressionListViewModelRead, WorkoutProgressionSearchParams } from 'src/app/_models/generatedModels';
import { ExerciseService } from 'src/app/_services/generatedServices';
import { AuthenticationService } from 'src/app/_services/authentication.service';
import { ToasterService } from 'src/app/_services/toaster.service';
import { BreadcrumbsService } from 'src/app/_services/breadcrumbs.service';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { ServerSortableList } from 'src/app/_helpers/serverSortableList';
import { WorkoutProgressionPreviewComponent } from './preview/workout-progression-preview.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'bxl-workout-progressions',
  templateUrl: 'workout-progressions.component.html',
})
export class WorkoutProgressionsComponent implements OnInit {

  initialized = false;
  progressions: ServerSortableList<WorkoutProgressionListViewModelRead>;
  currentPage: number = 1;
  itemsPerPage: number = 20;
  totalItems: number = 0;
  editUrl: string = '../workout-progressions/edit';
  currentProgressionId: number;
  currentProgressionName: string;
  searching: boolean = false;
  filterChanged: Subject<string> = new Subject<string>();
  filter = '';
  coachFilter: number = null;
  canEditGlobalLibrary: boolean = false;

  constructor(private exerciseService: ExerciseService, public auth: AuthenticationService, private toastr: ToasterService, private breadcrumbs: BreadcrumbsService, private modalService: NgbModal) { }

  ngOnInit(): void {
    this.breadcrumbs.SetSecondaryBreadcrumb('Workout Progressions', 'workout-progressions', []);
    this.canEditGlobalLibrary = this.auth.canEditGlobalLibrary();
    this.progressions = new ServerSortableList<WorkoutProgressionListViewModelRead>([], 'Name', false);
    this.searchProgressions();

    this.filterChanged.pipe(debounceTime(500), distinctUntilChanged()).subscribe((model) => {
      this.filter = model;
      this.currentPage = 1;
      this.searchProgressions();
    });

    this.progressions.sortChanged.subscribe(result => {
      this.currentPage = 1;
      this.searchProgressions();
    });
  }

  searchProgressions() {
    this.searching = true;
    let model = new WorkoutProgressionSearchParams();
    model.searchText = this.filter;
    model.page = this.currentPage;
    model.size = this.itemsPerPage;
    model.sortProperty = this.progressions.column;
    model.isSortDesc = this.progressions.isDesc;
    model.coachId = this.coachFilter;

    this.exerciseService.searchForWorkoutProgressions(model).subscribe((results) => {
      this.totalItems = results.rowCount;
      this.progressions.updateData(results.results);
      this.searching = false;
      this.initialized = true;
    });
  }

  onPreview(workoutProgressionId: number) {
    const modalRef = this.modalService.open(WorkoutProgressionPreviewComponent, { size: 'lg' });
    modalRef.componentInstance.workoutProgressionId = workoutProgressionId;
    modalRef.result.then(
      (result) => {},
      (reason) => {}
    );
  }

  onFilterChanged(query: string) {
    this.filterChanged.next(query);
  }

  pageChanged(event: any): void {
    this.searchProgressions();
  }

  onCoachFilterChange(event: any) {
    this.currentPage = 1;
    this.searchProgressions();
  }

  onDelete(workoutProgressionId: number) {
    this.toastr.confirmDialog('Are you sure you want to delete this workout progression? This action cannot be undone.', 'Delete Progression', 'Delete Progression', 'Cancel').subscribe(result => {
      if (result) {
        this.exerciseService.deleteWorkoutProgression(workoutProgressionId).subscribe(result => {
          this.progressions.remove(x => x.id === workoutProgressionId);
          this.toastr.success('Progression Deleted', 'Success');
        });
      }
    });
  }
}
